import { Pipe, PipeTransform, inject } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { RoleTypeKey } from '@core/authentication/auth/auth.constants'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'

@Pipe({ name: 'roleTranslate' })
export class RoleTranslatePipe implements PipeTransform {
  readonly #translate = inject(TranslateService)

  transform(value: any): Observable<string> {
    if (value) {
      return this.#translate
        .stream(value.map((v) => RoleTypeKey[v]))
        .pipe(map((roles) => Object.values(roles).join(', ')))
    }

    return of('')
  }
}
